import React from 'react';
import styled from 'styled-components';
import {useComponent} from '../component-library';

export const resultBarInViewProps = {
  rootMargin: '-80% 0% 0% 0%',
};

interface ResultBarProps {
  inView: boolean;
  headline: string;
  value: string;
  ref?: React.RefObject<HTMLDivElement>;
}

export const ResultBar = React.forwardRef<HTMLDivElement, ResultBarProps>(
  (props: ResultBarProps, ref): JSX.Element => {
    const TextInverted = useComponent('TextInverted');

    const handleResultBarClick = () => {
      const resultsBottomPosition = (
        ref as React.MutableRefObject<HTMLDivElement>
      ).current.getBoundingClientRect().bottom;
      const offsetPosition =
        resultsBottomPosition + window.scrollY - window.innerHeight + 20;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    };

    return (
      <ResultBarWrapper
        inView={props.inView}
        onMouseDown={handleResultBarClick}
      >
        <TextInverted tag="p" variant="copy" bold>
          {props.headline}
        </TextInverted>
        <TextInverted tag="p" variant="sticky-result" bold>
          {props.value}
        </TextInverted>
      </ResultBarWrapper>
    );
  }
);

interface ResultBarWrapperProps {
  inView: boolean;
}

const ResultBarWrapper = styled.div<ResultBarWrapperProps>`
  position: fixed;
  z-index: 10;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: ${(props) => props.theme.internal.size.static250}
    ${(props) => props.theme.internal.size.static400};
  transform: translateY(${(props) => (props.inView ? '0%' : '100%')});
  transition: transform 0.2s;
  border-top: ${(props) => props.theme.internal.size.border.light} solid
    ${(props) => props.theme.internal.border.color.secondary};
  background: ${(props) => props.theme.brand.colors.resultArea.background};

  @media (min-width: ${(props) => props.theme.internal.Breakpoints.b960}px) {
    display: none;
  }
`;
